import type { AlbumSong } from '../types'

export type AlbumOrderDirection = -1 | 1

export function orderedAlbumSongs(songs: AlbumSong[]): AlbumSong[] {
  return [...songs].sort((left, right) => left.order - right.order)
}

export function reorderedAlbumSongIds(
  songs: AlbumSong[],
  songId: number,
  direction: AlbumOrderDirection,
): number[] | null {
  const ordered = orderedAlbumSongs(songs)
  const index = ordered.findIndex((song) => song.songId === songId)
  if (index < 0) return null

  const target = index + direction
  if (target < 0 || target >= ordered.length) return null

  const next = [...ordered]
  ;[next[index], next[target]] = [next[target], next[index]]
  return next.map((song) => song.songId)
}
